import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoVendedorRanking(props) {
    
    const options = {
      series: props.series,
      chart: {
        height: 350,
        type: 'line',
      },
      stroke: {
        width: [0, 4]
      },
      title: {
        text: 'Ranking Vendedores'
      },
      dataLabels: {
        enabled: true,
        formatter : function (val) {
          return global.decimalFormat(val.toFixed(2))
        }
      },
      labels: props.vendedores,
      xaxis: {
        type: 'text'
      },
      yaxis: [{
        title: {
          text: 'Total Venta (S/)',
        },
        labels: {
          formatter : function (val) {
            return global.decimalFormat(val.toFixed(2))
          }
        }
      }, {
        opposite: true,
        title: {
          text: 'Cantidad Comprobantes'
        },
        labels: {
          formatter : function (val) {
            return global.decimalFormat(parseInt(val))
          }
        }
      }]
    };

    return (
      <div id="chart">
        <Chart options={options} series={options.series} type="line" height={450} />
      </div>
    );
}